<template>
  <transition name="slide-fade-down">
    <div class="Home">
      <router-link :to="{ name:'Swiper', params:{ slides:slides['A18'] } }"></router-link>
      <router-link :to="{ name:'Swiper', params:{ slides:slides['B18'] } }"></router-link>
      <router-link :to="{ name:'Swiper', params:{ slides:slides['C18'] } }"></router-link>
      <router-link :to="{ name:'Swiper', params:{ slides:slides['D18'] } }"></router-link>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'Home',

    data () {
      return {
        slides: {
          A18: [
            {
              background: 'Honda_ROBOTS_0001_02_A18_1.jpg',
              video: null
            },
            {
              background: 'Honda_ROBOTS_0002_03_A18_2.jpg',
              video: null
            },
            {
              background: 'Honda_ROBOTS_0003_04_A18_3.jpg',
              video: null
            },
            {
              background: 'Honda_ROBOTS_0004_05_A18_4.jpg',
              video: 'A18_page_04.mp4'
            },
            {
              background: 'Honda_ROBOTS_0005_06_A18_Final.jpg',
              video: null
            }
          ],

          B18: [
            {
              background: 'Honda_ROBOTS_0006_06_B18_1.jpg',
              video: null
            },
            {
              background: 'Honda_ROBOTS_0007_07_B18_2.jpg',
              video: null
            },
            {
              background: 'Honda_ROBOTS_0008_08_B18_3.jpg',
              video: 'B18_page_03.mp4'
            },
            {
              background: 'Honda_ROBOTS_0009_09_B18_4.jpg',
              video: 'B18_page_04.mp4'
            },
            {
              background: 'Honda_ROBOTS_0010_B18_Final.jpg',
              video: null
            }
          ],

          C18: [
            {
              background: 'Honda_ROBOTS_0011_10_C18_1.jpg',
              video: null
            },
            {
              background: 'Honda_ROBOTS_0012_11_C18_2.jpg',
              video: null
            },
            {
              background: 'Honda_ROBOTS_0013_12_C18_3.jpg',
              video: null
            },
            {
              background: 'Honda_ROBOTS_0015_14_C18_5.jpg',
              video: 'C18_page_05.mp4'
            },
            {
              background: 'Honda_ROBOTS_0016_C18_Final.jpg',
              video: null
            }
          ],

          D18: [
            {
              background: 'Honda_ROBOTS_0017_15_D18_1.jpg',
              video: null
            },
            {
              background: 'Honda_ROBOTS_0018_16_D18_2.jpg',
              video: 'D18_page_02.mp4'
            },
            {
              background: 'Honda_ROBOTS_0019_17_D18_3.jpg',
              video: null
            },
            {
              background: 'Honda_ROBOTS_0021_19_D18_5.jpg',
              video: 'D18_page_05.mp4'
            },
            {
              background: 'Honda_ROBOTS_0022_D18_Final.jpg',
              video: null
            }
          ]
        } // slides
      }
    }
  }
</script>

<style lang="scss">
  .Home {
    background-image: url('../assets/Honda_ROBOTS_0000_01_Landing.jpg');

    &.slide-fade-down-enter-active {
      transition: all .5s ease;
    }

    &.slide-fade-down-enter {
      transform: translateY(-100px);
      opacity: 0;
    }

    a {
      display: block;
      position: absolute;
      top: 370px;
      height: 380px;

      &:nth-child(1) {
        left: 150px;
        width: 150px;
      }

      &:nth-child(2) {
        left: 390px;
        width: 170px;
      }

      &:nth-child(3) {
        left: 630px;
        width: 190px;
      }

      &:nth-child(4) {
        left: 910px;
        width: 320px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue